exports.app = {
    title: "要闻列表",
    newsUrl: "https://www.fx2news.com",
};